<template>
  <div>
    <a v-if="project.permissions.project.share" class="btn-blue" href="#" @click="showing = true"><span>Share Project</span></a>
    <card-modal :showing="showing" @close="showing = false">
      <div class="flex flex-col gap-6" style="height: 50vh;">
        <div class="flex-none">
          <h2 class="font-bold text-2xl">Share Project</h2>
          <div class="border-b mt-4 pb-2">
            <a class="border-blue-600 text-gray-700 font-bold px-2 py-2 cursor-pointer hover:text-blue-600" :class="{'border-b-2' : tab === 0}" @click="tab = 0">Members</a>
            <a class="border-blue-600 text-gray-700 font-bold px-2 py-2 cursor-pointer hover:text-blue-600" :class="{'border-b-2' : tab === 1}" @click="tab = 1">Share</a>
          </div>
        </div>
        <div class="flex-auto " style="max-height: 80%;">
          <div v-if="tab === 0" class="h-full">
            <ul class="list-none overflow-y-auto" style="max-height: 84%;">
              <li v-for="member in project.members" :key="member.id" class="flex items-center justify-between mb-2 border-b pb-2">
                <div class="flex-auto flex items-center">
                  <div class="p-1 rounded-full w-10 h-10 flex items-center justify-center mr-3" :class="member.icon ? 'bg-blue-800' : 'bg-gray-600'">
                    <icon v-if="member.icon" class="w-5 h-5 fill-white" :name="member.icon" />
                  </div>
                  <div class="text-blue-700 flex flex-col">
                    <span class="font-bold">{{ member.name }}</span>
                    <span v-if="member.email">{{ member.email }}</span>
                  </div>
                </div>
                <div class="flex-auto flex items-center justify-end" placement="bottom-end">
                  <span v-if="member.owner">Owner</span>
                  <select v-else v-model="member.permission" @change="updateMember(member, $event.target.value)">
                    <option v-for="(v,k) in permissions" :key="k" :value="k">{{ v }}</option>
                    <option v-if="! member.owner" value="remove">Remove from project</option>
                  </select>
                </div>
              </li>
            </ul>
          </div>
          <div v-else class="h-full">
            <div class="flex items-end mb-4">
              <div class="flex-auto">
                <label class="form-label font-bold" :for="id">Invite with name or email</label>
                <input
                  :id="id" ref="input" class="border border-blue-600 relative px-6 py-3 w-full  focus:shadow-outline" autocomplete="off" type="text" name="search"
                  placeholder="Add project members by company, team or user email"
                  :value="modelValue"
                  @input="$emit('update:modelValue', $event.target.value)"
                />
              </div>
              <button v-if="modelValue" class="py-3 px-4 ml-3 text-gray-500 hover:text-gray-700 focus:text-blue-500 text-sm hover:border-gray-700" type="button" @click="$emit('reset')">Reset</button>
            </div>
            <ul class="list-none overflow-y-auto" style="max-height: 84%;">
              <li v-for="user in users" :key="user.id" class="mb-2 pb-2 flex items-center justify-between">
                <a class="cursor-pointer flex-auto flex items-center" @click="AddMember(user)">
                  <div class="p-1 rounded-full w-10 h-10 flex items-center justify-center mr-3" :class="user.icon ? 'bg-blue-800' : 'bg-gray-600'">
                    <icon v-if="user.icon" class="w-5 h-5 fill-white" :name="user.icon" />
                  </div>
                  <div class="text-blue-700 flex flex-col">
                    <span class="font-bold">{{ user.name }}</span>
                    <span>{{ user.email }}</span>
                  </div>
                </a>
                <div class="flex-auto flex items-center justify-end">
                  <select :value="user.permission ? user.permission : 1" @change="user.permission = $event.target.value">
                    <option v-for="(v, k) in permissions" :key="k" :value="k">{{ v }}</option>
                  </select>
                </div>
              </li>
              <li v-if="modelValue && users.length === 0">
                No users found.
              </li>
            </ul>
          </div>
        </div>
        <div class="flex-none text-right">
          <a class="border text-blue-800 border-blue-800 px-4 py-2 cursor-pointer hover:text-white  hover:bg-blue-600" @click.stop="showing = false">Close</a>
        </div>
      </div>
    </card-modal>
  </div>
</template>

<script>
import { v4 as uuid } from 'uuid'
import CardModal from '@/Shared/CardModal'
import Icon from '@/Shared/Icon'


export default {
  components: {
    CardModal,
    Icon,
  },
  props: {
    id: {
      type: String,
      default() {
        return `search-input-${uuid()}`
      },
    },
    project    : Object,
    modelValue : [String, Number],
    users      : Array,
    members    : Array,
    permissions: Object,
    company    : Object,
  },
  emits: [
    'update:modelValue',
    'reset',
  ],
  data() {
    return {
      showing: false,
      tab    : 0,
    }
  },
  computed: {
    errors() {
      return this.$page.props.errors
    },
    messages () {
      return {
        1: 'Are you sure you want to set the view permission for this user?',
        2: 'Are you sure you want to set the edit permission for this user?',
        3: 'Are you sure you want to replace the owner with this user ?',
        'remove': 'Are you sure you want to remove this user from this project, you can\'t undo this action?',
      }
    },
  },
  methods: {
    AddMember({id, type, permission}) {
      if (! permission) {
        permission = 1
      }

      if (confirm(this.messages[permission])) {
        this.$inertia.post(`/projects/${this.project.id}/members`, { id, type, permission},
          {
            onSuccess: () => {
              this.tab = 0
            },
          })
      }
    },
    updateMember({id, type }, permission) {

      if (confirm(this.messages[permission])) {
        this.$inertia.put(`/projects/${this.project.id}/members`, {id,type,permission },
          {
            onSuccess: () => {
              this.tab = 0
            },
          })
      }
    },
  },
}
</script>
